import React, { useEffect, useState } from "react";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import {
  TextField,
  Button,
  FormControl,
  Container,
  Grid,
  Box,
  Stack,
  OutlinedInput,
  InputLabel,
  MenuItem,
  ListItemText,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Modal,
  Typography,
} from "@mui/material";
// import "./test.css";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// import { bookApoinment } from "./asppoinmentApi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { routePath } from "../../constants/routePath";
import { setSession } from "../../utils/commonUtils";
import { setCustomerAppointmentId } from "../../app/store/reducer";
// import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { getAlldetailSerice } from "../services/servicesListApi";
import EmployeeModal from "../../common/employeeModel";
import PersonIcon from "@mui/icons-material/Person";
import { getItems } from "../items_services/itemApi";
import Swal from "sweetalert2";
import { swalAlertPopProps } from "../../utils/commonUtils"; // if you already have this

import {
  addCustomerAppointment,
  UpdatedCustomerAppointment,
} from "./appoinmentModalApi";
import { getAllEmployeeList } from "../employeeInfo/appoinmentDashboardApi";
import { ModalHeader } from "../../common/modalHeader";
import { TimeModal } from "./TimeModal";
import { ChooseSelect } from "../../common/chooseSelect";
dayjs.extend(utc);
dayjs.extend(timezone);

const Appoinmentadle = ({
  open,
  setOpen,
  apiCallback,
  selectedCustomer,
  setSelectedCustomer,
}) => {
  const [openT, setOpenT] = useState(false);
  const appnType = useSelector((state) => state.reducer.apppoinmentUerType);
  const dispatch = useDispatch();
  const info = useSelector((state) => state.reducer.detail);
  const struct = {
    billerId: "",
    customerName: "",
    mobileNumber: "",
    // otp: "",
    mailId: "",
    gender: "",
    service: "",
    date: "",
    hour: "",
    minute: "",
    status: "Unassigned",
    employeeId: "",
  };
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const [formData, setFormData] = useState({ ...struct });
  const [employeDetail, setEmployeeDetail] = useState(null);
  const [employeeList, setEmployeeList] = useState([]);
  const [dateValue, setDateValue] = useState(null);
  const [timeValue, setTimeValue] = useState(null);
  const [otpEnabled, setOtpEnabled] = useState(true);
  const [servicesList, setServicesList] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    // console.log()
    if (typeof value == "object") {
      setFormData({
        ...formData,
        [name]: value[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const setDate = (newValue) => {
    setDateValue(newValue);

    if (!newValue) return;

    const date = dayjs(newValue).tz("UTC").format("YYYY-MM-DDTHH:mm:ss");

    setFormData((prev) => ({
      ...prev,
      date: date,
    }));
  };

  //  const setTime = (newValue) => {
  //    setTimeValue(newValue);

  //    if (!newValue) return;

  //    setFormData((prev) => ({
  //      ...prev,
  //      hour: newValue.hour(),
  //      minute: newValue.minute(),
  //    }));
  //  };
  const setTime = (newValue) => {
    if (!newValue) {
      setTimeValue(null);
      setFormData((prev) => ({
        ...prev,
        hour: undefined,
        minute: undefined,
      }));
      return;
    }

    setTimeValue(newValue);
    setFormData((prev) => ({
      ...prev,
      hour: newValue.hour(),
      minute: newValue.minute(),
    }));
  };

  const handleTagsChange = (e) => {
    const { value } = e.target;

    console.log("val8e ", value);
    setFormData({
      ...formData,
      service: value,
    });
  };

  const gender = (e) => {
    setFormData((prev) => {
      let temp = { ...prev };
      if (e.target) {
        temp.gender = e.target.value;
      } else {
        temp.gender = e;
      }
      return { ...temp };
    });
  };

  const handleVerifymobileNumber = () => {
    if (formData.mobileNumber) {
      setOtpEnabled(true);
    }
  };
  const userDetail = useSelector((state) => state.reducer.userDetail);

  useEffect(() => {
    // console.log("purchase data businessChooseTab?.value", userDetail);
    if (userDetail && userDetail?.profileId) {
      let val = userDetail?.profileId?.split("?")[1];
      setFormData((prev) => {
        let pre = { ...prev };
        return {
          ...pre,
          billerId: Number(val.split("=")[1]?.replace(/\D/g, "")),
        };
      });
      console.log(
        "purchase data businessChooseTab?.value",
        val.split("=")[1]?.replace(/\D/g, "")
      );

      // getAllProdct(
      //   {
      //     billerId: val.split("=")[1]?.replace(/\D/g, ""),
      //   },
      //   (res) => {
      //     console.log("res getall product ", res?.data);
      //     setCollection([...res?.data]);
      //   }
      // );
    }
  }, [userDetail, open]);
  useEffect(() => {
    console.log("formData===", formData);
  }, [formData]);
  const navigate = useNavigate();

  const validateData = (data) => {
    if (!data.customerName || data.customerName.trim() === "") {
      return { status: false, message: "Customer name is required." };
    }
    if (!data.mobileNumber || data.mobileNumber.trim() === "") {
      return { status: false, message: "Mobile number is required." };
    }
    if (data.mobileNumber.length !== 10) {
      return {
        status: false,
        message: "Enter a valid 10-digit mobile number.",
      };
    }
    if (!data.service || data.service.length === 0) {
      return { status: false, message: "Please Select Service." };
    }
    if (!data.gender || data.gender.trim() === "") {
      return { status: false, message: "Gender is required." };
    }
    if (!data.date) {
      return { status: false, message: "Appointment date is required." };
    }
    if (data.hour === undefined || data.minute === undefined) {
      return { status: false, message: "Appointment time is required." };
    }
    return { status: true };
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let valid = validateData(formData);

    if (!valid.status) {
      Swal.fire({
        icon: "error",
        title: valid.message,
        ...swalAlertPopProps,
      });
      return;
    }
    // Transform service field into proper array of objects
    const transformedServices = (formData?.service || []).map((item) => ({
      service: item.service,
    }));

    const payload = {
      ...formData,
      date: formData.date,
      services: transformedServices,
      employeeId: Number(formData?.employeeId) || 0,
    };

    if (!selectedCustomer) {
      addCustomerAppointment(payload, async (re) => {
        apiCallback();
        setOpen(false);
        let val = userDetail?.profileId?.split("?")[1];
        setFormData((prev) => {
          let pre = { ...prev };
          return {
            ...struct,
            billerId: Number(val?.split("=")[1]?.replace(/\D/g, "")),
          };
        });
        resetForm();
      });
    } else {
      UpdatedCustomerAppointment(payload, async (re) => {
        apiCallback();
        setOpen(false);
        let val = userDetail?.profileId?.split("?")[1];
        setFormData((prev) => {
          let pre = { ...prev };
          return {
            ...struct,
            billerId: Number(val?.split("=")[1]?.replace(/\D/g, "")),
          };
        });
      });
    }

    console.log("final payload:", payload);
  };

  const [openTt, setOpenTt] = useState(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  const [servicesArr, setservicesArr] = useState([
    {
      serviceName: "Shaving",
      rate: "100.00/Per Head",
    },
    {
      serviceName: "Hair cutting",
      rate: "150.00/Per Head",
    },
  ]);
  const names = [
    "Haircut",
    "Hair Coloring",
    "Hair Styling",
    "Manicure",
    "Pedicure",
    "Facial",
    "Waxing",
    "Massage",
    "Makeup",
    "Bridal Makeup",
    "Threading",
    "Hair Spa",
    "Nail Art",
    "Skin Treatment",
  ];
  useEffect(() => {
    setFormData({
      ...formData,
      billerId: info.billerId,
    });
    // setDate(timeValue);
    // setTime(timeValue);
    // gender("male");
    getAllEmployeeList((res) => {
      console.log("getAllEmployeeList", res);
      setEmployeeList(res?.list);
    });
  }, []);
  const [pagination, setPagination] = useState({ page: 1, total: 1 });

  const infoD = useSelector((state) => state.reducer.detail);
  useEffect(() => {
    if (open === true) {
      getAlldetailSerice({ billerId: infoD?.billerId }, (res) => {
        setservicesArr(res?.data);
      });

      let pageSize = 30;
      getItems({ pagination, pageSize }).then((res) => {
        setServicesList(res?.data?.data);

        if (selectedCustomer) {
          const data = employeeList.findIndex(
            (ele) => ele.id == selectedCustomer?.employeeId
          );

          setFormData({ ...formData, ...selectedCustomer });

          if (data !== -1) {
            setEmployeeDetail(employeeList[data]);
          }

          setDateValue(dayjs(selectedCustomer?.date));
          setTimeValue(
            dayjs()
              .hour(selectedCustomer?.hour)
              .minute(selectedCustomer?.minute)
          );
        } else {
          // Leave timeValue and hour/minute empty
          setDateValue(null);
          setTimeValue(null);
          setFormData((prev) => ({
            ...prev,
            hour: undefined,
            minute: undefined,
          }));
        }
      });
    }
  }, [open]);

  function formatTimeTo12Hour(hour24, minute) {
    if (
      hour24 === undefined ||
      minute === undefined ||
      hour24 === null ||
      minute === null
    ) {
      return "";
    }
    const hour = hour24 % 12 || 12;
    const min = minute.toString().padStart(2, "0");
    const noon = hour24 >= 12 ? "PM" : "AM";
    return `${hour} : ${min} ${noon}`;
  }
  const resetForm = () => {
    setFormData({ ...struct });
    setDateValue(null);
    setTimeValue(null);
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
        setFormData({ ...struct });
        resetForm();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "50%", md: "43%", lg: "43%", xl: "43%" },

          position: "absolute",
          left: { sm: "29%", xs: "2%" },
          top: "10%",
          borderRadius: "10px",
        }}
      >
        <ModalHeader
          title={"Book an Appoinments"}
          onClose={(data) => {
            setOpen(data);
            setFormData({ ...struct });
          }}
        />
        <Container>
          <Box
            sx={{
              my: 2,
              overflowY: "auto",
              height: "70vh",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <form onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <FormControl fullWidth sx={{ marginY: "4px" }}>
                    <TextField
                      size="small"
                      label={
                        <span>
                          Customer Name: <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="customerName"
                      value={formData.customerName}
                      onChange={handleChange}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth sx={{ marginY: "2px" }}>
                    <TextField
                      size="small"
                      label="Email Id:"
                      name="mailId"
                      type="email"
                      value={formData.mailId}
                      onChange={handleChange}
                      // required
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth sx={{ marginY: "2px" }}>
                    <TextField
                      label={
                        <span>
                          Mobile Number: <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="mobileNumber"
                      size="small"
                      type="tel"
                      inputProps={{
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        maxLength: 10,
                      }}
                      value={formData.mobileNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setFormData({
                          ...formData,
                          mobileNumber: value.slice(0, 10),
                        });
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      InputProps={{
                        classes: { input: "mulish" },
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12}>
                  <Box
                    sx={{
                      padding: "8px",
                      border: "2px solid #5857b3",
                      borderRadius: "5px",
                    }}
                  >
                    <Typography
                      sx={{
                        paddingX: "5px",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                    >
                      Service: <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <ChooseSelect
                      dataprop={formData?.service}
                      setDatat={(data) => {
                        setFormData({ ...formData, service: data });
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <FormLabel
                        id="demo-row-radio-buttons-group-label"
                        className="mulish"
                        sx={{
                          marginRight: 2,
                          color: "primary.main",
                          fontSize: { xs: "12px", sm: "13px", md: "18px" },

                          fontWeight: 500,
                        }}
                      >
                        Gender: <span style={{ color: "red" }}>*</span>
                      </FormLabel>
                      <RadioGroup
                        row
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="row-radio-buttons-group"
                        sx={{
                          "& .MuiFormControlLabel-root": {
                            height: 45,
                            marginY: 0,
                          },
                        }}
                      >
                        <FormControlLabel
                          value="Female"
                          control={<Radio sx={{ p: 0.5 }} />}
                          checked={formData.gender == "Female"}
                          label="Female"
                          InputLabelProps={{
                            className: "mulish",
                            fontSize: { xs: "12px", sm: "13px", md: "20px" },
                            sx: {
                              color: "#545454",
                              fontWeight: 400,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              paddingX: "7px",
                            },
                          }}
                          sx={{
                            color: "primary.main",
                            height: 45,
                            marginY: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" }, // ✅ label font size
                              fontFamily: "Mulish",
                              fontWeight: 500,
                            },
                          }}
                          className="mulish"
                          onClick={gender}
                        />
                        <FormControlLabel
                          value="Male"
                          control={<Radio sx={{ p: 0.5 }} />}
                          checked={formData.gender == "Male"}
                          label="Male"
                          InputLabelProps={{
                            className: "mulish",
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            sx: {
                              color: "#545454",
                              fontWeight: 400,
                              fontSize: { xs: "12px", sm: "13px", md: "15px" },
                              paddingX: "7px",
                            },
                          }}
                          sx={{
                            color: "primary.main",
                            height: 45,
                            marginY: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" }, // ✅ label font size
                              fontFamily: "Mulish",
                              fontWeight: 500,
                            },
                          }}
                          className="mulish"
                          onClick={gender}
                        />
                        <FormControlLabel
                          value="Other"
                          control={<Radio sx={{ p: 0.5 }} />}
                          checked={formData.gender == "Other"}
                          sx={{
                            color: "primary.main",
                            height: 45,
                            marginY: 0,
                            "& .MuiFormControlLabel-label": {
                              fontSize: { xs: "12px", sm: "13px", md: "15px" }, // ✅ label font size
                              fontFamily: "Mulish",
                              fontWeight: 500,
                            },
                          }}
                          label="Other"
                          InputLabelProps={{
                            className: "mulish",
                            fontSize: { xs: "12px", sm: "13px", md: "20px" },
                          }}
                          className="mulish"
                          onClick={gender}
                        />
                      </RadioGroup>
                    </Box>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth sx={{ marginY: "2px" }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={
                          <span>
                            Select Date: <span style={{ color: "red" }}>*</span>
                          </span>
                        }
                        value={dateValue}
                        minDate={dayjs()}
                        format="DD-MMM-YYYY"
                        onChange={(newValue) => {
                          setDate(newValue);
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            InputLabelProps: {
                              className: "mulish",
                              sx: {
                                color: "#545454",
                                fontWeight: 400,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                paddingX: "7px",
                              },
                            },
                            InputProps: {
                              classes: { input: "mulish" },
                              sx: {
                                height: 45,
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                              },
                            },
                            sx: { "& .MuiInputBase-root": { height: 45 } },
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth sx={{ marginY: "2px" }}>
                    <TextField
                      fullWidth
                      id="Value"
                      readOnly={true}
                      label={
                        <span>
                          Time: <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      value={
                        formData?.hour !== undefined &&
                        formData?.minute !== undefined
                          ? formatTimeTo12Hour(formData?.hour, formData?.minute)
                          : ""
                      }
                      onChange={(e) => {}}
                      InputProps={{
                        sx: {
                          height: 45,
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        },
                        endAdornment: (
                          <AccessTimeIcon
                            onClick={() => {
                              setOpenTt(true);
                            }}
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                              cursor: "pointer",
                            }}
                          />
                        ),
                      }}
                      InputLabelProps={{
                        className: "mulish",
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      sx={{ "& .MuiInputBase-root": { height: 45 } }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl fullWidth sx={{ marginY: "2px" }}>
                    <TextField
                      fullWidth
                      id="Value"
                      readOnly={true}
                      label="Employee"
                      InputLabelProps={{
                        shrink: !!employeDetail?.name,
                        sx: {
                          color: "#545454",
                          fontWeight: 400,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                          paddingX: "7px",
                        },
                      }}
                      value={employeDetail?.name}
                      onChange={(e) => {}}
                      InputProps={{
                        sx: {
                          height: 45,
                          sx: {
                            color: "#545454",
                            fontWeight: 400,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "7px",
                          },
                        },
                        endAdornment: (
                          <PersonIcon
                            onClick={() => {
                              setOpenT(true);
                              setFormData((prev) => {
                                let temp = { ...prev };
                                temp.employeeId = employeDetail?.id;
                                console.log("employee detail", employeDetail);
                                return temp;
                              });
                            }}
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                              cursor: "pointer",
                            }}
                          />
                        ),
                      }}
                      sx={{ "& .MuiInputBase-root": { height: 45 } }}
                    />
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    paddingX: "40px !important",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{
                      width: "100%",
                      backgroundColor: "primary.main",
                      fontSize: { xs: "12px", sm: "13px", md: "16px" },

                      height: 45,
                    }}
                  >
                    {selectedCustomer ? "Update" : "Book"} an Appointment
                  </Button>
                  {businessChooseTab?.value == "Unasigned" && (
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      sx={{
                        width: "100%",
                        backgroundColor: "#3695B6",
                        fontSize: { xs: "12px", sm: "13px", md: "16px" },

                        height: 45,
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                </Grid>
              </Grid>
            </form>
          </Box>
        </Container>{" "}
        <EmployeeModal
          open={openT}
          setOpen={setOpenT}
          callback={(data) => {
            setOpenT(false);
            setEmployeeDetail(data);
            setFormData((prev) => {
              let temp = { ...prev };
              temp.employeeId = data?.id;
              console.log("employee detail", data);
              return temp;
            });
            console.log(data, "callback ");
          }}
          onClose={() => {
            setOpenT(false);
          }}
          employeeList={employeeList}
        />
        <TimeModal
          open={openTt}
          data={formData}
          setOpen={setOpenTt}
          date={(tt) => {
            setFormData((prev) => {
              let tempP = { ...prev };
              if (tt?.noon == "PM") {
                tempP.hour = tt?.hour + 12;
                tempP.minute = parseInt(tt?.min);
                tempP["noon"] = "PM";
              } else {
                tempP.hour = tt?.hour;
                tempP.minute = parseInt(tt?.min);
                tempP["noon"] = "AM";
              }
              return { ...tempP };
            });
            setOpenTt(false);
          }}
        />
      </Box>
    </Modal>
  );
};

export default Appoinmentadle;
